<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00039.installation.coffret' | translate"
      [description]="'P00039.installation.coffretTexte' | translate"
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P00039.installation.coffret.antenneDeporte' | translate"
      [titleListe]="'P00039.installation.coffret.antenne' | translate"
      [value]="actionStack!.getValue('maitreITypeAntenneRF')"
      [liste]="P00039AntenneTypeEnum"
      [description]="'P00039.installation.coffret.text.antenna' | translate"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.Maitre_Installation,
          'maitreITypeAntenneRF',
          $event,
          null
        )
      "
    >
    </app-label-configuration>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
